var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.429,
    height: 12,
    viewBox: "0 0 21.429 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1328",
    d: "M27.6 40.588h-7.279a1.04 1.04 0 1 0 0 2.079H27.6zm0 2.079h9.43l-3.32 3.223a1.026 1.026 0 0 0 0 1.472 1.1 1.1 0 0 0 1.517 0l5.141-4.991a1.026 1.026 0 0 0 0-1.472l-5.141-4.991a1.1 1.1 0 0 0-1.441.058 1.018 1.018 0 0 0-.076 1.4l3.32 3.223H27.6z",
    transform: "translate(-19.25 -35.666)",
    style: {
      fill: "#ea7d36"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c6a3c7b4748f10bce59d974ba58a8b0e.svg";
export { ForwardRef as ReactComponent };